import axios from 'axios'

export const NavigatorApi = {
    http: axios.create()
}
